import { CloseButton, Dialog } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';

import LoginForm from '@features/login/LoginForm';
import { useBoolean } from 'hooks/useBoolean';
import useCloseModal from 'hooks/useCloseModal';
import { useStores } from 'stores/rootStore';

const LoginModal = () => {
  const { pageStore } = useStores();
  const [signUp, setSignUp] = useBoolean(false);
  const onClose = useCloseModal();
  const isOpen = pageStore.isLoginModalOpen();

  return (
    <Dialog.Root size="full" lazyMount open={isOpen} onOpenChange={onClose}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content bgColor="surface.background">
          <Dialog.Body p={2}>
            <Dialog.CloseTrigger asChild alignSelf="flex-start">
              <CloseButton size="sm" _hover={{ bgColor: 'button.secondary.hover' }} />
            </Dialog.CloseTrigger>
            <LoginForm signUp={signUp} onClickSignUp={setSignUp.toggle} />
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export default observer(LoginModal);
